const getter = {
  count: (state) => state.count,
  loginInfos: (state) => state.loginInfos,
  history: (state) => state.historySearch
};
export default getter
